(function () {
  'use strict';
  document.querySelectorAll('.hh-faner').forEach(function (gruppe) {
    var sek = gruppe.closest('section');
    gruppe.querySelectorAll('[data-hh-fane]').forEach(function (knap) {
      knap.addEventListener('click', function () {
        var n = knap.getAttribute('data-hh-fane');
        gruppe.querySelectorAll('[data-hh-fane]').forEach(function (k) {
          var aktiv = k === knap;
          k.classList.toggle('is-valgt', aktiv);
          k.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        });
        sek.querySelectorAll('[data-hh-fane-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-hh-fane-panel') !== n;
        });
      });
    });
  });
})();
